var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-component',{attrs:{"gridId":_vm.gridId,"fields":_vm.fields,"itemData":_vm.qboItems}})}
var staticRenderFns = []

export { render, staticRenderFns }